export default __webpack_public_path__ + "static/Poppins-Black-eacee5bb9c7fee5939aebf2335e5106a.ttf";